import './ProductGuaranteeList.css'

import { axiosConfig, eventEmitter, lang } from '../../common/baseData'
import React, { useEffect, useState } from 'react'
import ProductGuaranteeCard from '../productGuaranteeCard/ProductGuaranteeCard'
import ProductServiceCard from '../productServiceCard/ProductServiceCard'
import BatteryServiceCard from '../batteryServiceCard/BatteryServiceCard'
import DefaultGuaranteeCard from '../defaultGuaranteeCard/DefaultGuaranteeCard'
import LoadingBlock from '../loadingBlock'
import axios from 'axios'

function ProductGuaranteeList (props) {

  const [state, setState] = useState({
    guarantees: props.guarantees || [],
    services: props.services || [],
    batteryServices: props.batteryServices || [],
    category: props.category || {},
    messages: props.messages || {},
    productId: props.productId || false,
    productPrice: props.productPrice || false,
    productWarrantyPeriod: props.productWarrantyPeriod || false,
  })
  const refreshUrl = props.refreshUrl || null
  const params = props.params || {}
  const [checkedWarrantyId, setCheckedWarrantyId] = useState(0)
  const [checkedBatteryServiceId, setCheckedBatteryServiceId] = useState(0)
  const [showAdditionalServices, setShowAdditionalServices] = useState(false)
  const [showBatteryServices, setShowBatteryServices] = useState(false)
  const [showGuaranteeList, setShowGuaranteeList] = useState(false)

  useEffect(() => {
    // событие обновления данных при обновлении корзины
    eventEmitter.on('basketUpdated', params => {
      refreshData()
    })

    // обработка события изменения корзины через api
    eventEmitter.on('basketStateChanged', params => {
      refreshData()
    })
  }, [])

  useEffect(() => {
    const productPrice = Number(state.productPrice) || 0
    const warrantyPrice = getSelectedItemPrice(state.guarantees, checkedWarrantyId)
    const servicePrice = getSelectedItemPrice(state.batteryServices, checkedBatteryServiceId)
    const totalPrice = productPrice + warrantyPrice + servicePrice

    eventEmitter.emit('productPriceChanged', {
      price: totalPrice
    })
  }, [
    checkedWarrantyId,
    checkedBatteryServiceId,
    state.productPrice,
    state.guarantees,
    state.batteryServices
  ])

  function getSelectedItemPrice (items, selectedId) {
    if (!selectedId) return 0

    const selectedItem = items.find(item => parseInt(item.ID) === parseInt(selectedId))

    if (!selectedItem || !selectedItem.PRICE) return 0

    return Number(selectedItem.PRICE.DISCOUNT_PRICE) || 0
  }

  /**
   * Refreshes the data by making a POST request to the specified URL with the provided parameters.
   * Sets the state with the retrieved data on success, and logs any errors to the console.
   *
   * @param {Object} params - The parameters to be sent with the request.
   * @param {string} refreshUrl - The URL to send the request to.
   * @param {Object} axiosConfig - The configuration object for Axios.
   * @returns {void}
   */
  function refreshData () {
    // Загрузка списка товаров
    let formData = new FormData()

    formData.append('params', params)
    formData.append('lang', lang)

    axios.post(refreshUrl, formData, axiosConfig)
      .then(response => {
        setState(response.data)
      })
      .catch(error => {
        console.error(error)
      })
  }

  /**
   * Retrieves a list of DOM nodes representing the product basket buttons.
   *
   * @return {NodeList} The list of DOM nodes representing the product basket buttons.
   */
  function productBasketButtonNodeList () {
    return [].slice.apply(document.querySelectorAll(`[data-container="buy"][data-use="order"][data-product-id="${state.productId}"]`))
  }

  /**
   * Removes deferred product IDs from the main product buttons.
   *
   * @return {void}
   */
  function removeDeferredProductsFromProduct () {
    let nodeList = productBasketButtonNodeList()
    // снимаем с основного товара
    if (!nodeList.length) return

    nodeList.forEach(item => {
      if (item instanceof HTMLElement) {
        item.removeAttribute('data-add-product-ids')
      }
    })
  }

  function setDeferredProducts (...selectedProductIds) {
    const productIds = [...new Set(selectedProductIds
      .map(productId => parseInt(productId))
      .filter(productId => productId > 0))]

    productBasketButtonNodeList().forEach(item => {
      if (!(item instanceof HTMLElement)) return

      item.removeAttribute('data-add-product-ids')

      if (productIds.length > 0) {
        item.setAttribute('data-add-product-ids', productIds.join(','))
      }
    })
  }

  /**
   * Событие смены состояния гарантии
   * @param event
   */
  function onCheckQuarantee (event) {
    let mainProductInBasket = false
    let productId = parseInt(event.target.value)
    let warrantyInBasket = false
    try {
      let basketItemsMap = JSON.parse(localStorage.getItem('basketItemsMap')) || {}
      mainProductInBasket = !!basketItemsMap.hasOwnProperty(state.productId)
      warrantyInBasket = !!basketItemsMap.hasOwnProperty(productId)
    } catch (e) {
      console.log(e)
    }

    // основной товар в корзине
    if (mainProductInBasket) {
      // добавляем товар в корзину
      if (!warrantyInBasket) {
        eventEmitter.emit('addToCart', {
          productId: productId,
          openWindow: false,
          mainProductId: state.productId
        })
      }
      // очистка добавления гарантии она уже в корзине
      removeDeferredProductsFromProduct()
      setCheckedWarrantyId(productId)
    } else {
      // пробрасываем выбранные дополнения в основной товар
      setDeferredProducts(productId, checkedBatteryServiceId)
      // устанавливаем выбранный элемент
      setCheckedWarrantyId(productId)
    }
  }

  /**
   * Событие выбора основной гарантии
   *
   * @param event
   */
  function onCheckDefaultQuarantee (event) {
    // проверяем наличие гарантии в корзине
    if (checkedWarrantyId) {
      // формируем данные для удаления из корзины
      let basketItemsMap = JSON.parse(localStorage.getItem('basketItemsMap')) || {}
      let productId = checkedWarrantyId
      let inBasket = basketItemsMap.hasOwnProperty(productId)
      let cartId = null

      // определяем запись в корзине
      state.guarantees.map(quarantee => {
        if (quarantee.hasOwnProperty('ACTIVE') && quarantee.ACTIVE && quarantee.hasOwnProperty('CART_ID') &&
          parseInt(quarantee.CART_ID) > 0)
          cartId = parseInt(quarantee.CART_ID)
      })

      // удаляем из корзины
      if (inBasket && cartId) {
        eventEmitter.emit('removeFromCart', {
          productId: productId,
          cartId: cartId,
          openWindow: false
        })
      }

      if (basketItemsMap.hasOwnProperty(state.productId)) {
        removeDeferredProductsFromProduct()
      } else {
        setDeferredProducts(0, checkedBatteryServiceId)
      }

      setCheckedWarrantyId(0)
    }
  }

  /**
   * Событие смены состояния доп услуги
   *
   * @param event
   */
  function onCheckService (event) {
    let productId = parseInt(event.target.value)
    let inBasket = false
    let checked = event.target.checked
    let cartId = null

    try {
      let basketItemsMap = JSON.parse(localStorage.getItem('basketItemsMap')) || {}
      inBasket = !!basketItemsMap.hasOwnProperty(productId)
      if (inBasket) cartId = basketItemsMap[productId]
    } catch (error) {
      console.log(error)
    }

    // Товар в корзине
    if (inBasket && !checked && cartId) {
      eventEmitter.emit('removeFromCart', {
        productId: productId,
        cartId: cartId,
        openWindow: false
      })
    } else if (checked && productId) {
      // не в корзине и не был выбран, выбор сейчас
      eventEmitter.emit('addToCart', {
        productId: productId,
        openWindow: false
      })
    }
  }

  function toggleShowAdditionalServices (event) {
    event.preventDefault()
    setShowAdditionalServices(!showAdditionalServices)
  }

  function getBasketItemsMap () {
    try {
      return JSON.parse(localStorage.getItem('basketItemsMap')) || {}
    } catch (error) {
      console.log(error)
      return {}
    }
  }

  function removeBatteryServices (exceptProductId = 0) {
    const basketItemsMap = getBasketItemsMap()

    state.batteryServices.forEach(service => {
      const serviceId = parseInt(service.ID)

      if (serviceId === exceptProductId || !basketItemsMap.hasOwnProperty(serviceId)) return

      eventEmitter.emit('removeFromCart', {
        productId: serviceId,
        cartId: basketItemsMap[serviceId],
        openWindow: false
      })
    })
  }

  function onCheckBatteryService (event) {
    const productId = parseInt(event.target.value)
    const basketItemsMap = getBasketItemsMap()
    const mainProductInBasket = basketItemsMap.hasOwnProperty(state.productId)

    if (mainProductInBasket) {
      removeBatteryServices(productId)

      if (!basketItemsMap.hasOwnProperty(productId)) {
        eventEmitter.emit('addToCart', {
          productId: productId,
          openWindow: false,
          mainProductId: state.productId
        })
      }
    } else {
      setDeferredProducts(checkedWarrantyId, productId)
    }

    setCheckedBatteryServiceId(productId)
  }

  function onCheckDefaultBatteryService () {
    const basketItemsMap = getBasketItemsMap()

    if (basketItemsMap.hasOwnProperty(state.productId)) {
      removeBatteryServices()
      removeDeferredProductsFromProduct()
    } else {
      setDeferredProducts(checkedWarrantyId, 0)
    }

    setCheckedBatteryServiceId(0)
  }

  function toggleShowBatteryServices (event) {
    event.preventDefault()
    setShowBatteryServices(!showBatteryServices)
  }

  const defaultQuarantee = () => {
    return <DefaultGuaranteeCard checkedWarrantyId={checkedWarrantyId}
                                 name={`${state.messages['BASIC_WARRANTY']} (${state.productWarrantyPeriod})`}
                                 price={`0 ₴`}
                                 onCheckQuarantee={onCheckDefaultQuarantee}
                                 messages={state.messages}/>
  }

  // Делим гарантии на первую и остальные
  const firstGuaranteeCard = () => {
      return <ProductGuaranteeCard checkedWarrantyId={checkedWarrantyId}
                                   key="first-guarantee"
                                   {...state.guarantees[0]}
                                   onCheckQuarantee={onCheckQuarantee}
                                   messages={state.messages}/>
  };


  const remainingGuaranteesList = state.guarantees.slice(1).map((guarantee, key) => {
    return <ProductGuaranteeCard checkedWarrantyId={checkedWarrantyId}
                                 key={key}
                                 {...guarantee}
                                 onCheckQuarantee={onCheckQuarantee}
                                 messages={state.messages}/>
  })

  const serviceList = state.services.map((service, key) => {
    if (key < 3 || showAdditionalServices)
      return <ProductServiceCard key={key}
                                 {...service}
                                 onCheckService={onCheckService}
                                 messages={state.messages}/>
  })

  const batteryServiceList = state.batteryServices.map((service, key) => {
    if (key < 3 || showBatteryServices)
      return <BatteryServiceCard key={service.ID}
                                      {...service}
                                      checkedBatteryServiceId={checkedBatteryServiceId}
                                      onCheckBatteryService={onCheckBatteryService}/>
  })

  return (
    <>
      {
        state.guarantees.length > 0 ?
          <>
            <hr className="product-info-line relink-line mt-5 mb-[20px] ml-[-20px] from-tablet:mb-[20px] max-xl:mt-[13px] max-xl:mb-[20px] max-xl:ml-[-20px] max-md:hidden desktop:ml-[-30px]" />
            <div className="protect-services-holder" id="protect-services-holder">
              {
                state.batteryServices.length > 0 ?
                  <div className="protect-your-phone-holder battery-services-holder">
                    <div className="protect-your-phone-title">{state.messages['BATTERY_CONDITION']}</div>
                    <div className="protect-guarantee-list">
                      <div className="default-protect-guarantee-item">
                        <div className="protect-guarantee-content">
                          <input type="radio"
                                 name="battery-service"
                                 id="battery-service-default"
                                 value={0}
                                 onChange={onCheckDefaultBatteryService}
                                 checked={!checkedBatteryServiceId}/>
                          <label htmlFor="battery-service-default">
                            <div className="protect-guarantee-item-into">
                              <span className="protect-guarantee-item-title">
                                {state.messages['STANDARD_BATTERY']}
                              </span>
                            </div>
                          </label>
                        </div>
                      </div>
                      {batteryServiceList}
                      {
                        state.batteryServices.length > 3 ?
                          <a href="#" className="guarantee-show-more" onClick={toggleShowBatteryServices}>
                            {showBatteryServices ? state.messages['SHOW_LESS'] : state.messages['SHOW_MORE']}
                          </a> :
                          <></>
                      }
                    </div>
                  </div> :
                  <></>
              }
              <div className="protect-your-phone-holder">
                {/** заголовок от корневой категории товара **/}
                {
                  state.category.hasOwnProperty('NAME') ?
                    <div className="protect-your-phone-title">{state.messages['PROTECT_YOUR']} </div> :
                    <></>
                }
                {/** список гарантий **/}
                <div className="protect-guarantee-list">
                  {defaultQuarantee()}
                  {firstGuaranteeCard()}
                  {showGuaranteeList && remainingGuaranteesList}
                </div>
                {
                  state.guarantees.length > 1 && !showGuaranteeList &&
                  <div
                    className={'show-more-guarantee relative font-normal mt-[11px] pl-[2px] cursor-pointer text-blue-primary w-max leading-[20px] border-solid border-t-0 border-l-0 border-r-0 border-b border-transparent hover:border-blue-primary'}
                    onClick={() => setShowGuaranteeList(!showGuaranteeList)}>{state.messages['TO_EXTEND_WARRANTY']}</div>
                }
              </div>
              {
                state.services.length > 0 ?
                  <div className="additional-services-holder">
                    <div className="additional-services-title">{state.messages['ADDITIONAL_SERVICES']}:</div>
                    <div className="additional-services-list">
                      {serviceList}
                      {
                        state.services.length > 3 ?
                          <a href="#" className="guarantee-show-more" onClick={toggleShowAdditionalServices}>
                            {showAdditionalServices ? state.messages['SHOW_LESS'] : state.messages['SHOW_MORE']}
                          </a> :
                          <></>
                      }
                    </div>
                  </div> :
                  <></>
              }
            </div>
          </> : <></>
      }
    </>
  )
}

export default ProductGuaranteeList
